const docEn = {
    boq: require('../../lang/en/doc/Boq').default,
    datasheet: require('../../lang/en/doc/Datasheet').default,
};

export default docEn;